import React from 'react';
import { Link } from 'react-router-dom'; // Using React Router for navigation

const SynapseProteomesSection = () => {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center mb-10">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
            Synapse proteomes
          </h2>
          
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            SynaptopathyDB integrates synapse proteome data from 64 studies that report a 
            total of 8351 proteins. We defined a consensus set of 3,437 synaptic proteins 
            each supported by evidence from at least five independent studies.
          </p>
        </div>
        
        <div className="mt-8 flex justify-center">
          <Link 
            to="/gene-table" 
            className="inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Synapse proteome list
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SynapseProteomesSection;